import { getPlaceDetails, selectPlaceData } from 'containers/MapDetails/placeSlice'
import WarehouseAttrPopup from '../Popups/WarehouseAttrPopup'
import GalleryPopup from 'components/popups/GalleryPopup'
import { useHistory, useParams } from 'react-router-dom'
import AutomationPopup from '../Popups/AutomationPopup'
import { useDispatch, useSelector } from 'react-redux'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useEffect, useState } from 'react'
import MmRating from 'components/MmRating'

const PlaceElement = ({ idx, data, scrollMenu, warehouseTypeId }) => {
  const { id, isAnnouncement, mm_score, mm_score_info, automation, place_attrs, important_attrs, city, street, estateNumber, localNumber, sizes, photos } = data || {}
  const { push, replace, goBack } = useHistory()
  const { popup, openPopup } = usePopupState()

  const dispatch = useDispatch()
  const { t } = useTranslation('map')
  const { placeId: placeIdParams } = useParams()
  const { tabs } = useSelector(selectPlaceData)

  const [activeSize, setActiveSize] = useState(null)
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [expandedIndex, setExpandedIndex] = useState(null)

  useEffect(() => {
    dispatch(getPlaceDetails(placeIdParams))
  }, [placeIdParams, dispatch])

  useEffect(() => {
    if (sizes && sizes.length > 0) {
      const newSize = warehouseTypeId
        ? (sizes.find(s => s.warehouseTypeId === warehouseTypeId) || sizes[0])
        : sizes[0]
      setActiveSize(newSize)
    }
  }, [sizes, warehouseTypeId])

  const handleGo = () => {
    if (isAnnouncement) {
      openPopup({ type: 'announcement', placeId: id })
    } else {
      if (idx !== undefined) replace(`${window.location.pathname}?from=mag_${idx}`)
      push(`/mapdetails/${id}${activeSize ? `?warehouseTypeId=${activeSize.warehouseTypeId}` : ''}`)
    }
  }

  return (
    <>
      {popup === 'warehouse_attr' && <WarehouseAttrPopup body={place_attrs} />}
      {popup === 'automation' && <AutomationPopup body={automation} />}
      {popup?.type === 'gallery' && <GalleryPopup initialSlide={popup.index} data={photos} />}

      <div
        className='placeElement'
        onScroll={scrollMenu}>
        <div className='placeElement__name'>
          <h2>{city}, {street} {localNumber} {estateNumber}</h2>
          {typeof mm_score === 'number' && <MmRating
            number={mm_score}
            action={() => openPopup({ type: 'mm_score', scoreInfo: mm_score_info })}
          />}
          <div className='buttonGo' onClick={handleGo}>
            <i className='icon icon--arrow-right s24'></i>
          </div>
        </div>

        {place_attrs && place_attrs.length > 0 && <div className='placeElement__attr' onClick={() => openPopup('warehouse_attr')}>
          {place_attrs.map((item) => {
            return (
              <div key={item.id} className='placeElement__attr__item'>
                <i className={`icon icon--check`}></i>
                <span>{item.name}</span>
              </div>
            )
          })}
        </div>}

        <div className='placeElement__automation' onClick={() => openPopup('automation')}>
          <div>
            {automation.key === 'full-automatic'
              ? <i className='icon icon--shield'></i>
              : ''}
            <span className={`${automation.key === 'full-automatic' ? 'green' : ''}`}>{automation.title}</span>
          </div>
          <div>{automation.description}</div>
        </div>

        <div className='placeElement__sizes'>
          <span className='subtitle'>{t('availableSizes')}</span>
          {sizes.map((item, idx) => {
            return (
              <div
                key={idx}
                className={`sizeItem ${item.warehouseTypeId === (activeSize && activeSize.warehouseTypeId) ? 'active' : ''}`}
                onClick={() => setActiveSize(item)}>
                {item.sizeShortName || item.size}
              </div>
            )
          })}
        </div>

        <div className='placeElement__price'>
          <span className='subtitle'>{t('costOfSelectedSize')}</span>
          <span className='--secFont'>{t('from')} {activeSize?.monthlyGrossPrice}</span>
          <span className='--secFont small'>/ {t('monthly')}</span>
        </div>

        {photos && photos.length > 0 && <div className='placeElement__photos'>
          {photos.map((item, idx) => {
            return (
              <img
                key={idx}
                alt=''
                src={item.public_path}
                onClick={() => {
                  openPopup({ type: 'gallery', index: idx })
                }} />
            )
          })}
        </div>}

        <div className='placeElement__important'>
          {important_attrs.map((item, idx) => {
            const isExpanded = expandedIndex === idx
            return (
              <div key={idx} className='placeElement__important__item'>
                <div
                  className='placeElement__important__item__main'
                  onClick={() => setExpandedIndex(expandedIndex === idx ? null : idx)}>
                  <i className={`icon icon--${item.key}`}></i>
                  <span>{item.name}</span>
                  <i className='icon icon--info'></i>
                </div>
                <div className={`placeElement__important__item__addons ${isExpanded ? 'active' : ''}`}>
                  {item.description}
                </div>
              </div>
            )
          })}
        </div>

        <div className='placeElement__tabs'>
          <div className='placeElement__tabs__head'>
            {tabs?.map((tab, index) => (
              <span key={index} className={activeTabIndex === index ? 'active' : ''} onClick={() => setActiveTabIndex(index)}>
                {tab.name}
              </span>
            ))}
          </div>

          {tabs && <div className='placeElement__tabs__body'>
            {tabs[activeTabIndex].type === 'list'
              ? (tabs[activeTabIndex].content.map((item, index) => (
                <div key={index} className='list__item'>
                  <i className={`icon icon--${item.icon}`}></i>
                  <span>{item.name}</span>
                  <span>{item.description}</span>
                </div>
              )))
              : (<div className='htmlFromApi' dangerouslySetInnerHTML={{ __html: tabs[activeTabIndex].content }} />)}
          </div>}
        </div>
      </div>

      <div className='placeElement__bottomBar'>
        <button
          className='button --back'
          onClick={goBack}>{t('backToMap')}</button>
        <ArrowBtn
          enlarged
          text={t(isAnnouncement ? 'seeTheOffer' : 'seeTheWarehouses')}
          action={handleGo} />
      </div>
    </>
  )
}

export default PlaceElement